import { calculateDateRange, getDashboardPriorPeriodBounds } from '../../utils/dates';
import { buildAnalyticsPeriodParams } from '../../utils/periodParams';

class BillingDelegate {
    handleBillingTimeFrameChange(timeFrame) {
        const nextDateRange = timeFrame === 'custom' ? this.state.dateRange : null;
        this.persistBillingPeriod(timeFrame, nextDateRange);
        this.setState({ timeFrame, dateRange: nextDateRange }, async () => {
            if (timeFrame !== 'custom') await this.refreshBillingData({ timeFrame, dateRange: nextDateRange });
            else if (nextDateRange?.[0] && nextDateRange?.[1]) {
                await this.refreshBillingData({ timeFrame, dateRange: nextDateRange });
            }
        });
    }

    handleBillingDateRangeChange(dates) {
        if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
            this.persistBillingPeriod('custom', null);
            this.setState({ dateRange: null });
            return;
        }
        this.persistBillingPeriod('custom', dates);
        this.setState({ timeFrame: 'custom', dateRange: dates }, async () => {
            await this.refreshBillingData({ timeFrame: 'custom', dateRange: dates });
        });
    }

    async refreshBillingData(period = this.state) {
        const { timeFrame, dateRange } = period;
        if (timeFrame === 'custom' && (!dateRange?.[0] || !dateRange?.[1])) {
            return;
        }

        const { start, end } = calculateDateRange(timeFrame, dateRange);
        if (!start || !end) {
            return;
        }

        this.setState({ kpiLoaded: false, statementsLoaded: false });

        const priorBounds = timeFrame !== 'custom'
            ? getDashboardPriorPeriodBounds(timeFrame, dateRange)
            : null;
        const priorBillableUsersPromise = priorBounds
            ? this.data.fetchBillingBillableUsers(
                buildAnalyticsPeriodParams(timeFrame, dateRange, {
                    forceCustom: true,
                    start: priorBounds.start.format('YYYY-MM-DD'),
                    end: priorBounds.end.format('YYYY-MM-DD'),
                }),
            )
            : Promise.resolve(undefined);

        const [kpiRaw, billableUsersRaw, statementsRaw, priorBillableUsersRaw] = await Promise.all([
            this.data.fetchBillingKPIs(start, end),
            this.data.fetchBillingBillableUsers(buildAnalyticsPeriodParams(timeFrame, dateRange)),
            this.data.fetchBillingStatements(start, end),
            priorBillableUsersPromise,
        ]);

        const baseKpi =
            kpiRaw && typeof kpiRaw === 'object' && Object.keys(kpiRaw).length > 0 ? kpiRaw : {};
        const kpiData = this.mergeBillableFromAnalytics(baseKpi, billableUsersRaw, priorBillableUsersRaw);

        this.setState({
            kpiData,
            kpiLoaded: true,
            statements: Array.isArray(statementsRaw) ? statementsRaw : [],
            statementsLoaded: true,
        });
    }

    handleSelectStatement(statementId) {
        const selectedStatements = new Set(this.state.selectedStatements);
        if (selectedStatements.has(statementId)) {
            selectedStatements.delete(statementId);
        } else {
            selectedStatements.add(statementId);
        }
        this.setState({ selectedStatements });
    }

    handleSelectAll() {
        const { statements } = this.state;
        if (this.state.selectedStatements.size === statements.length) {
            this.setState({ selectedStatements: new Set() });
        } else {
            this.setState({ selectedStatements: new Set(statements.map((s) => s.id)) });
        }
    }
}

export default BillingDelegate;
